import { FC } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "../hooks/ReduxHooks";
import Loader from "../components/UI/loader/Loader";
import NotFoundPage from "../components/pages/not-found/NotFoundPage";
import { operatorRole } from "../redux/types/OperatorTypes";

const OperatorRoutes: FC = () => {
  const { operator, authLoading, isAuthChecked } = useAppSelector(
    (state) => state.operator,
  );

  const location = useLocation();

  if (authLoading || !isAuthChecked) {
    return <Loader />;
  }

  const isDev = operator?.role === operatorRole.DEV;
  const isAdmin = operator?.role === operatorRole.ADMIN;
  const isGSC = operator?.role === operatorRole.CENTER_OPERATOR;

  const isDeveloperTicketsPage =
    location.pathname === "/operator/developer-tickets";

  if (isGSC) {
    if (isDeveloperTicketsPage) {
      return <Outlet />;
    }

    return <NotFoundPage />;
  }

  if (isDev || isAdmin || operator) {
    return <Outlet />;
  }

  return <NotFoundPage />;
};

export default OperatorRoutes;
